import { Stack, styled } from "@mui/material";

export const AddSystemChargeWrapper = styled(Stack)(({ theme }) => {
    return {
        gap: "var(--flex-gap)",
        padding: "var(--basic-padding)",
        backgroundColor: "var(--light-color)",
        borderRadius: "16px",
        overflow: "hidden",
        "& form": {
            display: "flex",
            flexDirection: "column",
            gap: "var(--flex-gap)",
        },
        "& fieldset": {
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
        },
    }
});